/** ******************************************************************************* */
/* Position selection -- allows selection of place from map or by autocompletion  */
/* - map drawing tool: circle and polygon                                         */
/** ******************************************************************************* */

Bingo.Map.PositionSelection = function (mapSelector, mapping, originPage) {
    Bingo.Map.Instance.call(this, Bingo.Map.MODE_POSITION_SELECT, mapSelector, originPage);
    this.initialized = false;
    this.position = null;
    this.positionMarkerChanged = null;

    this.lastLocation = null;

    this._circle = null;
    this._circleLabel = null;
    this._polygon = null;
    this._marker = null;
    this._target = null;
    this._localitiesDrawings = [];

    this.MAX_ZOOM_LEVEL = 16;

    if (mapping) {
        if (mapping.hasOwnProperty('location')) {
            this.LOCATION_FIELD = mapping.location;
        } else {
            this.LOCATION_FIELD = 'location';
        }
        if (mapping.hasOwnProperty('locality')) {
            this.LOCALITY_FIELD = mapping.locality;
        } else {
            this.LOCALITY_FIELD = 'localityId';
        }
        if (mapping.hasOwnProperty('radius')) {
            this.RADIUS_FIELD = mapping.radius;
        } else {
            this.RADIUS_FIELD = 'radius';
        }
        if (mapping.hasOwnProperty('coordinates')) {
            this.COORDINATES_FIELD = mapping.coordinates;
        } else {
            this.COORDINATES_FIELD = 'coordinates';
        }
        if (mapping.hasOwnProperty('polygon')) {
            this.POLYGON_FIELD = mapping.polygon;
        } else {
            this.POLYGON_FIELD = 'polygon';
        }
        if (mapping.hasOwnProperty('draw')) {
            this.DRAW_FIELD = mapping.draw;
        } else {
            this.DRAW_FIELD = 'draw';
        }
    }
    let field = document.getElementById(this.RADIUS_FIELD);

    this.localitySelectize = false;

    if (!field || !field.value > 0) {
        field = Bingo.Map.FALLBACK_RADIUS;
    } else {
        field = field.value;
    }
    this.radius = field * 1000;

    this.MARKER_PROTOTYPE = {
        url: '/src/images/markers/target.svg?{{buildVersion}}',
        size: new google.maps.Size(64, 64),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(16, 16),
        scaledSize: new google.maps.Size(32, 32),
    };

    this.drawingMode = google.maps.drawing.OverlayType.NONE;


    if (this._originPage === Bingo.Map.ORIGIN_PAGE_MODE.DEMAND) {
        $(`#${this.RADIUS_FIELD}`).on('change', () => {
            this._circle.setRadius(parseInt($(`#${this.RADIUS_FIELD}`).val()) * 1000);
        });
    }
};
Bingo.Map.PositionSelection.prototype = Object.create(Bingo.Map.Instance.prototype);

/**
 * Initializas map, draws circle/polygon and initializes rest of functionality
 */
Bingo.Map.PositionSelection.prototype.init = function () {
    const localityElement = document.getElementById(this.LOCALITY_FIELD);
    if (localityElement) {
        this.localitySelectize = localityElement.selectize;
    }

    if (!this.getArea()) {
        const locationFromForm = this.getFormCoordinates();
        const polygonPoints = this.getFormPolygon();
        const formDraw = this.getFormDraw();
        this.processLocalitiesFromInput();
        this.setFormDraw(formDraw);
        Bingo.Map.Instance.prototype.init.call(this, locationFromForm);
        if (this.localitySelectize
            && this.localitySelectize.getValue() === ''
            && polygonPoints.length > 0
            && (
                this.getFormDraw() === '1'
                || this._originPage === Bingo.Map.ORIGIN_PAGE_MODE.DEMAND
            )
        ) {
            const newPolygon = Bingo.Map.PositionSelectionPolygonOptions;

            newPolygon.paths = polygonPoints;
            newPolygon.map = this.getArea();

            const tempPolygon = new google.maps.Polygon(newPolygon);
            if (this.isPolygonValid(tempPolygon)) {
                this._polygon = tempPolygon;

                if (this.localitySelectize) {
                    this.localitySelectize.setCustomLocalities();
                }
                this.addPolygonListeners();
                this.getArea().fitBounds(tempPolygon.getBounds());

                if (this._originPage === Bingo.Map.ORIGIN_PAGE_MODE.DEMAND) {
                    $(`input#${this.LOCATION_FIELD}`).closest('div.form-group').hide();
                }

                $(`input#${this.LOCATION_FIELD}`).attr('disabled', 'disabled');
                this.drawingMode = null;
            } else {
                tempPolygon.setMap(null);
                $(`input#${this.POLYGON_FIELD}`).val('');
            }
        }

        if (locationFromForm && (this.getFormDraw() === '1' || this._originPage === Bingo.Map.ORIGIN_PAGE_MODE.DEMAND)) {
            const newCircle = Bingo.Map.PositionSelectionCircleOptions;

            newCircle.center = locationFromForm;
            newCircle.radius = this.radius;
            newCircle.map = this.getArea();

            this._circle = new google.maps.Circle(newCircle);

            if (this.localitySelectize) {
                this.localitySelectize.setCustomLocalities();
            }
            $(`input#${this.LOCATION_FIELD}`).closest('div.form-group').show();

            this.addCircleListeners();
            this.updateLastLocation();
            this.addCircleLabel();
            this.drawTargetMarker(locationFromForm);
            this.drawingMode = null;
        }

        // Try to center if geolocation is allowed by the browser and user and the location was not restored
        if (this.enableGeoLocation && navigator.geolocation && this._circle === null && this._polygon === null) {
            const setNewPosition = function (position) {
                this.userLocation = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
                this.userLocationUsed = false;
                if ($(this.getIdSelector()).is(':visible')) {
                    this.useUserLocation();
                }
            }.bind(this);
            navigator.geolocation.getCurrentPosition(setNewPosition, () => {
                navigator.geolocation.getCurrentPosition(setNewPosition, null, {maximumAge: Infinity, timeout: 0}); // Otherwise we take anything relevant now.
            }, {maximumAge: 3600000, timeout: 5000}); // First we try to take at most 1 hr old position withing 5 second timeout.
        }

        if (!this.getArea()) {
            this.showLoadingFailed();
            return;
        }
    }
    if (!this.initialized) {
        this.initialized = true; // ASAP to prevent multiple initializations

        this._map = this.getArea();
        if (this._originPage === Bingo.Map.ORIGIN_PAGE_MODE.NEW_OFFER || this._originPage === Bingo.Map.ORIGIN_PAGE_MODE.PROJECT) {
            this.initDrawingOnlyMarker();
        } else {
            this.initDrawing();
        }
        this.initAutocompletion();
        this.initLocation();
    }
};

Bingo.Map.PositionSelection.prototype.redrawLocalitiesDrawings = function () {
    this.removeLocalitiesDrawings();
    if (this.localities.length > 0) {
        this.setDrawingModeNone();
        this.unsetDrawings();
        $(Bingo.Map.PositionSelectionDrawClear).addClass('-hidden');
        this.localities.forEach((locality) => {
            if (typeof locality.polygon !== 'undefined' && locality.polygon !== null) {
                const points = [];
                const pointsRaw = locality.polygon.split(';');
                for (let i = 0; i < pointsRaw.length; i++) {
                    //  get rid of last point, which is beginning
                    if (i === (pointsRaw.length - 1) && pointsRaw[0] === pointsRaw[pointsRaw.length - 1]) {
                        break;
                    }
                    points.push(this.extractCoordinates(pointsRaw[i]));
                }
                const newPolygon = Object.assign({}, Bingo.Map.PositionSelectionPolygonOptions);

                newPolygon.id = Math.floor((Math.random() * 9999999));
                newPolygon.paths = points;
                newPolygon.editable = false;
                newPolygon.map = this.getArea();

                const localityPolygon = new google.maps.Polygon(newPolygon);

                this._localitiesDrawings.push(localityPolygon);
            } else if (typeof locality.circle !== 'undefined' && locality.circle !== null) {
                const newCircle = Object.assign({}, Bingo.Map.PositionSelectionCircleOptions);

                if (locality.circle.center.indexOf('POINT') !== -1) {
                    newCircle.center = this.extractCoordinatesFromDbPoint(locality.circle.center);
                } else {
                    newCircle.center = this.extractCoordinates(locality.circle.center);
                }
                newCircle.radius = locality.circle.radius * 1000;
                newCircle.editable = false;
                newCircle.map = this.getArea();

                const localityCircle = new google.maps.Circle(newCircle);

                this._localitiesDrawings.push(localityCircle);
                this.getArea().fitBounds(localityCircle.getBounds());
            }
        });

        const bounds = new google.maps.LatLngBounds();
        this._localitiesDrawings.forEach(
            (localityPolygon) => {
                bounds.union(localityPolygon.getBounds());
            },
        );

        this.getArea().fitBounds(bounds);
    }
};

Bingo.Map.PositionSelection.prototype.addLocalityCircleListeners = function (localityCircle) {
    localityCircle.addListener('radius_changed', () => {
        localityCircle.setOptions({strokeOpacity: 1});
        this._circle = localityCircle;
        localityCircle.target.setMap(null);
        localityCircle.label.setMap(null);
        this._localitiesDrawings = this._localitiesDrawings.filter(locPol => locPol.id !== localityCircle.id);
        this.removeLocalitiesDrawings();
        this.handleCircle();
    });

    localityCircle.addListener('center_changed', () => {
        localityCircle.setOptions({strokeOpacity: 1});
        localityCircle.target.setMap(null);
        localityCircle.label.setMap(null);
        this._circle = localityCircle;
        this._localitiesDrawings = this._localitiesDrawings.filter(locPol => locPol.id !== localityCircle.id);
        this.handleCircle();
    });
};

Bingo.Map.PositionSelection.prototype.removeLocalitiesDrawings = function () {
    this._localitiesDrawings.map((localityDrawing) => {
        localityDrawing.setMap(null);
        if (typeof localityDrawing.target !== 'undefined') {
            localityDrawing.target.setMap(null);
        }
        if (typeof localityDrawing.label !== 'undefined') {
            localityDrawing.label.setMap(null);
        }
        return localityDrawing;
    });
    this._localitiesDrawings = [];
};
/**
 * initializes drawing functionality
 * @param google.map map
 */
Bingo.Map.PositionSelection.prototype.initDrawing = function () {
    this._drawingManager = new google.maps.drawing.DrawingManager({
        drawingMode: this.drawingMode,
        drawingControl: false,
        drawingControlOptions: {
            position: google.maps.ControlPosition.TOP_CENTER,
            drawingModes: ['circle', 'polygon'],
        },
        circleOptions: Bingo.Map.PositionSelectionCircleOptions,
        polygonOptions: Bingo.Map.PositionSelectionPolygonOptions,
    });

    this._drawingManager.setMap(this._map);
    this.initDrawingButtons();

    google.maps.event.addListener(this._drawingManager, 'circlecomplete', (circle) => {
        this.unsetDrawings();
        this._circle = circle;
        this.addCircleListeners();
        this.handleCircle();
    });

    google.maps.event.addListener(this._drawingManager, 'polygoncomplete', (polygon) => {
        // Ignore invalid polygons
        if (!this.isPolygonValid(polygon)) {
            polygon.setMap(null);
            return;
        }
        this.unsetDrawings();
        this._polygon = polygon;
        this.addPolygonListeners();
        this.handlePolygon();
    });
};

Bingo.Map.PositionSelection.prototype.isPolygonValid = function (polygon) {
    // Certain number of vertices is required and atleast 0.01 square meters of area
    let minimalCount = 3;
    // If the path start = end then four points are needed
    if (polygon.getPath().length >= 2 && polygon.getPath().getAt(0).equals(polygon.getPath().getAt(polygon.getPath().length - 1))) {
        minimalCount = 4;
    }
    return polygon.getPath().length >= minimalCount && google.maps.geometry.spherical.computeArea(polygon.getPath()) >= 0.01;
};

Bingo.Map.PositionSelection.prototype.initDrawingButtons = function () {
    Bingo.OfferFilterForm.hideOptionsSwitch();
    $(Bingo.Map.PositionSelectionDrawToolElement).show();
    $(Bingo.Map.PositionSelectionDrawToolElement).on(
        'click',
        Bingo.Map.PositionSelectionDrawCircle,
        () => { this.showClearLocalityModal(this.setDrawingModeCircle.bind(this)); },
    );
    $(Bingo.Map.PositionSelectionDrawToolElement).on(
        'click',
        Bingo.Map.PositionSelectionDrawPolygon,
        () => { this.showClearLocalityModal(this.setDrawingModePolygon.bind(this)); },
    );
    $(Bingo.Map.PositionSelectionDrawToolElement).on(
        'click',
        Bingo.Map.PositionSelectionDrawClear,
        this.drawingModeReset.bind(this),
    );

    if (this._circle !== null) {
        this.setLastActive($(Bingo.Map.PositionSelectionDrawCircle));
    }
    if (this._polygon !== null) {
        this.setLastActive($(Bingo.Map.PositionSelectionDrawPolygon));
    }
    if (this._polygon === null && this._circle === null) {
        $(Bingo.Map.PositionSelectionDrawClear).addClass('-hidden');
    }

    switch (this.drawingMode) {
        case 'circle':
            this.setDrawingModeCircle();
            break;
        case 'polygon':
            this.setDrawingModePolygon();
            break;
        default:
            break;
    }
};

Bingo.Map.PositionSelection.prototype.drawingModeReset = function () {
    this.unsetDrawings();
    this.unsetActiveTool();
    this.unsetLastActiveTool();
    this.setDrawingModeNone();
    $(Bingo.Map.PositionSelectionDrawClear).addClass('-hidden');
    if (Bingo.OfferFilterForm !== undefined) {
        Bingo.OfferFilterForm.clearLocationFields();
        Bingo.OfferFilterForm.doFilter();
    }

    if (this.localitySelectize) {
        this.localitySelectize.removeCustomLocalities(false);
    }
};

Bingo.Map.PositionSelection.prototype.setDrawingModeNone = function () {
    this._drawingManager.setDrawingMode(null);
    this.unsetActiveTool();
    this.closeInfoWindow();
};

Bingo.Map.PositionSelection.prototype.setDrawingModeCircle = function () {
    this.unsetDrawings();

    if (this.localitySelectize) {
        this.localitySelectize.autoSubmit = false;
        this.localitySelectize.setValue(null);
        this.localitySelectize.removeCustomLocalities(false);
        this.localitySelectize.autoSubmit = true;
    }
    if ($(Bingo.Map.PositionSelectionDrawCircle).hasClass('active-tool') || $(Bingo.Map.PositionSelectionDrawCircle).hasClass('active-last')) {
        this.drawingModeReset();
    } else {
        this.setDrawingModeNone();
        this._drawingManager.setDrawingMode('circle');
        this.setLastActive($(Bingo.Map.PositionSelectionDrawCircle));
        $(Bingo.Map.PositionSelectionDrawClear).removeClass('-hidden');
    }
};

Bingo.Map.PositionSelection.prototype.isDrawingModeActive = function () {
    return this._drawingManager.getDrawingMode() !== null;
};

Bingo.Map.PositionSelection.prototype.showClearLocalityModal = function (callback) {
    if (this._localitiesDrawings.length > 0) {
        const data = $(`#${Bingo.Map.ClearLocalitiesConfirmModalId}`).data();
        Bingo.Bootstrap.Confirmation.show({
            ...data,
            onConfirm() {
                callback();
            },
        });
    } else {
        callback();
    }
};

Bingo.Map.PositionSelection.prototype.setDrawingModePolygon = function () {
    this.unsetDrawings();
    if (this.localitySelectize) {
        this.localitySelectize.autoSubmit = false;
        this.localitySelectize.setValue(null);
        this.localitySelectize.removeCustomLocalities(false);
        this.localitySelectize.autoSubmit = true;
    }
    if ($(Bingo.Map.PositionSelectionDrawPolygon).hasClass('active-tool') || $(Bingo.Map.PositionSelectionDrawPolygon).hasClass('active-last')) {
        this.drawingModeReset();
    } else {
        this.setDrawingModeNone();
        this._drawingManager.setDrawingMode('polygon');
        this.setLastActive($(Bingo.Map.PositionSelectionDrawPolygon));
        $(Bingo.Map.PositionSelectionDrawClear).removeClass('-hidden');
    }
};

/**
 * initializes drawing functionality
 * @param google.map map
 */
Bingo.Map.PositionSelection.prototype.initDrawingOnlyMarker = function () {
    this._drawingManager = new google.maps.drawing.DrawingManager({
        drawingMode: google.maps.drawing.OverlayType.MARKER,
        drawingControl: false,
        drawingControlOptions: {
            position: google.maps.ControlPosition.TOP_CENTER,
            drawingModes: ['marker'],
        },
        markerOptions: Bingo.Map.PositionSelectionMarkerOptions,
    });
    this._drawingManager.setMap(this._map);

    google.maps.event.addListener(this._drawingManager, 'markercomplete', (marker) => {
        this.unsetDrawings();
        this._marker = marker;
        this.handleMarker(true);
    });
};


/**
 * Fires after marker change. Adds data to the form and it.
 */
Bingo.Map.PositionSelection.prototype.handleMarker = function (fromMap = false) {
    if (!fromMap && $(`#${this.LOCATION_FIELD}`).val()) {
        this.syncLocation(this._marker.position, $(`#${this.LOCATION_FIELD}`).val());
    } else {
        this.syncLocation(this._marker.position);
    }
    $(`#${this.COORDINATES_FIELD}`).val(`${this._marker.position.lat().toFixed(6)},${this._marker.position.lng().toFixed(6)}`);
    if (this.positionMarkerChanged !== null) {
        this.positionMarkerChanged();
    }
};


/**
 * Fires after circle change. Adds data to the form and it.
 */
Bingo.Map.PositionSelection.prototype.handleCircle = function () {
    this.radius = this._circle.getRadius();
    $(`input#${this.RADIUS_FIELD}`).val(this.radius / 1000);
    $(`#${this.POLYGON_FIELD}`).val(null);
    $(`input#${this.LOCATION_FIELD}`).removeAttr('disabled');

    if (this.localitySelectize) {
        this.localitySelectize.autoSubmit = false;
        this.localitySelectize.setValue(null);
        this.localitySelectize.setCustomLocalities();
        this.localitySelectize.autoSubmit = true;
    }
    this.setFormDraw(true);

    if (this._originPage === Bingo.Map.ORIGIN_PAGE_MODE.DEMAND) {
        $(`input#${this.LOCATION_FIELD}`).closest('div.js-textField').show();
    }

    this.syncLocation(this._circle.center);
    $(`#${this.COORDINATES_FIELD}`).val(`${this._circle.center.lat().toFixed(6)},${this._circle.center.lng().toFixed(6)}`);
    if (this.positionMarkerChanged !== null) {
        this.positionMarkerChanged();
    }

    this.addCircleLabel();
    this.drawTargetMarker(this._circle.center);
    this.setDrawingModeNone();
};

Bingo.Map.PositionSelection.prototype.handleLocalities = function () {
    $(`input#${this.RADIUS_FIELD}`).val(null);
    $(`#${this.POLYGON_FIELD}`).val(null);
    $(`input#${this.LOCATION_FIELD}`).val(null).closest('div.js-textField').hide();

    this.setFormDraw(true);
};

/**
 * Adds radius in km to the top of circle
 */
Bingo.Map.PositionSelection.prototype.addCircleLabel = function (circle, disableDrag) {
    if (this._circleLabel) {
        this._circleLabel.setMap(null);
    }
    if (typeof circle === 'undefined') {
        circle = this._circle;
    }
    this._circleLabel = this.addCircleLabelObject(circle, disableDrag);
    // Add listeners for interactive change of circle radius via dragging circle label
    // The listeners for circle needs to be suspended to prevent complete redraw and sync stopping interactivity
    if (typeof disableDrag === 'undefined' || !disableDrag) {
        this._circleLabel.addListener('dragstart', () => {
            this.removeCircleListeners();
        });
        this._circleLabel.addListener('drag', () => {
            this.changeRadius(google.maps.geometry.spherical.computeDistanceBetween(circle.getCenter(), this._circleLabel.getPosition()));
        });
        this._circleLabel.addListener('dragend', () => {
            this.changeRadius(google.maps.geometry.spherical.computeDistanceBetween(circle.getCenter(), this._circleLabel.getPosition()));

            this.addCircleListeners();
            this.handleCircle();
        });
    }
};


Bingo.Map.PositionSelection.prototype.addCircleLabelObject = function (circle, disableDrag) {
    const labelCoordinates = google.maps.geometry.spherical.computeOffset(circle.center, circle.getRadius(), 90);
    const labelContent = `${Math.round(circle.getRadius() / 100) / 10} km`;
    const charWidth = 8;
    let labelTextSize = labelContent.length * charWidth;
    if (!labelContent.includes('.')) {
        labelTextSize += 4;
    }
    const labelSize = labelTextSize + 30;
    return new google.maps.Marker({
        label: {
            text: labelContent,
            fontSize: '12px',
            color: '#31393C',
            fontWeight: 'bold',
        },
        position: labelCoordinates,
        map: this.getArea(),
        zIndex: 1,
        icon: {
            url: '/src/images/map-circle-label.png',
            size: new google.maps.Size(labelSize, 29),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(0, 15),
            labelOrigin: new google.maps.Point(parseInt((labelTextSize / 2) + 6), 14),
        },
        draggable: (typeof disableDrag === 'undefined' || !disableDrag),
    });
};

/**
 * Change radius of circle in place (without redrawing everything and without syncing it to the form)
 * Notes:
 *  - Expects to operate without listeners on circle (which would spoil it)
 *  - That you ensure synchronization manually (typically after drag end)
 */
Bingo.Map.PositionSelection.prototype.changeRadius = function (newRadius) {
    this.radius = newRadius;
    this._circle.setRadius(newRadius);
};

/**
 * Fires after polygon change. Adds data to the form and executes it.
 */
Bingo.Map.PositionSelection.prototype.handlePolygon = function () {
    vertices = this._polygon.getPath();

    const points = [];
    for (let i = 0; i < vertices.getLength(); i++) {
        const point = vertices.getAt(i);
        points.push(`${point.lat().toFixed(6)},${point.lng().toFixed(6)}`);
    }
    //  add first point to close the circle
    points.push(points[0]);

    if (this.localitySelectize) {
        this.localitySelectize.autoSubmit = false;
        this.localitySelectize.setValue(null);
        this.localitySelectize.setCustomLocalities();
        this.localitySelectize.autoSubmit = true;
    }

    $(`#${this.POLYGON_FIELD}`).val(points.join(';'));
    $(`input#${this.RADIUS_FIELD}`).val(null);
    $(`input#${this.COORDINATES_FIELD}`).val(null);
    $(`input#${this.LOCATION_FIELD}`).val(null).attr('disabled', 'disabled');

    this.setFormDraw(true);

    if (this._originPage === Bingo.Map.ORIGIN_PAGE_MODE.DEMAND) {
        $(`input#${this.LOCATION_FIELD}`).closest('div.js-textField').hide();
    }


    if (this._originPage !== Bingo.Map.ORIGIN_PAGE_MODE.DEMAND) {
        triggerOfferSearchForm($(`input#${this.POLYGON_FIELD}`).closest('form'));
    }
    this.setDrawingModeNone();
    this.setLastActive($(Bingo.Map.PositionSelectionDrawPolygon));
    $(Bingo.Map.PositionSelectionDrawClear).removeClass('-hidden');
};

Bingo.Map.PositionSelection.prototype.drawNormalMarker = function (location) {
    if (this._marker) {
        this._marker.setMap(null);
    }
    const marker = Bingo.Map.PositionSelectionMarkerOptions;
    marker.position = location;
    marker.map = this.getArea();
    this._marker = new google.maps.Marker(marker);
};

/**
 * Adds radius in km to the top of circle
 */
Bingo.Map.PositionSelection.prototype.drawTargetMarker = function (location) {
    if (this._target) {
        this._target.setMap(null);
    }

    const target = Bingo.Map.PositionSelectionTargetOptions;
    target.position = location;
    target.map = this.getArea();
    target.zIndex = 1;

    this._target = new google.maps.Marker(target);
    // Add listeners for interactive change of circle location via dragging target marker
    // The listeners for circle needs to be suspended to prevent complete redraw and sync stopping interactivity
    this._target.addListener('dragstart', () => {
        this.removeCircleListeners();
    });
    this._target.addListener('drag', () => {
        this.moveCircle(this._target.getPosition);
    });
    this._target.addListener('dragend', () => {
        this.moveCircle(this._target.getPosition);

        this.addCircleListeners();
        this.handleCircle();
    });
};

/**
 * Moves circle in place (without redrawing everything and without syncing it to the form)
 * Notes:
 *  - Expects to operate without listeners on circle (which would spoil it)
 *  - That you ensure synchronization manually (typically after drag end)
 */
Bingo.Map.PositionSelection.prototype.moveCircle = function () {
    this._circle.setCenter(this._target.getPosition());
    this.position = this._target.getPosition();
    this._circleLabel.setPosition(google.maps.geometry.spherical.computeOffset(this._circle.center, this._circle.getRadius(), 90));
};

/**
 * Adds listeners for (newly) created circle
 */
Bingo.Map.PositionSelection.prototype.addCircleListeners = function () {
    this._circle.addListener('radius_changed', () => {
        this.handleCircle();
    });

    this._circle.addListener('center_changed', () => {
        this.handleCircle();
    });
};

/**
 * Removes listeners for circle
 */
Bingo.Map.PositionSelection.prototype.removeCircleListeners = function () {
    google.maps.event.clearListeners(this._circle, 'radius_changed');
    google.maps.event.clearListeners(this._circle, 'center_changed');
};


/**
 * Adds listeners for newly created polygon
 */
Bingo.Map.PositionSelection.prototype.addPolygonListeners = function () {
    this._polygon.getPath().addListener('set_at', () => {
        this.handlePolygon();
    });

    this._polygon.getPath().addListener('insert_at', () => {
        this.handlePolygon();
    });
};

/**
 * When drawing new circle/polygon, then first we need to delete previous ones.
 */
Bingo.Map.PositionSelection.prototype.unsetDrawings = function (resetBindedValues = true) {
    if (this._circle !== null) {
        this._circle.setMap(null);
        this._circle = null;
    }
    if (this._polygon !== null) {
        this._polygon.setMap(null);
        this._polygon = null;
    }
    if (this._circleLabel) {
        this._circleLabel.setMap(null);
    }
    if (this._target) {
        this._target.setMap(null);
    }
    if (this._marker) {
        this._marker.setMap(null);
    }

    this.removeLocalitiesDrawings();

    // Reset location field disabled flag
    $(`input#${this.LOCATION_FIELD}`).removeAttr('disabled');

    // Reset binded values in the form
    if (resetBindedValues) {
        $(`input#${this.COORDINATES_FIELD}`).val('');
        $(`input#${this.RADIUS_FIELD}`).val('');
        $(`input#${this.POLYGON_FIELD}`).val('');
    }

    //  unset draw attribute to enable bounding box search execution
    this.setFormDraw(false);
};

/**
 * @param callback
 */
Bingo.Map.PositionSelection.prototype.setPositionMarkerChanged = function (callback) {
    this.positionMarkerChanged = callback;
};

Bingo.Map.PositionSelection.prototype.getFormLocation = function () {
    const element = document.getElementById(this.LOCATION_FIELD);
    if (!element || !element.value) {
        return null;
    }
    return element.value;
};

Bingo.Map.PositionSelection.prototype.getFormCoordinates = function () {
    const element = document.getElementById(this.COORDINATES_FIELD);
    if (!element || !element.value) {
        return null;
    }
    return this.extractCoordinates(element.value);
};

Bingo.Map.PositionSelection.prototype.getFormPolygon = function () {
    const element = document.getElementById(this.POLYGON_FIELD);
    const points = [];
    if (!element || !element.value || element.value === null) {
        return points;
    }

    const pointsRaw = element.value.split(';');
    for (let i = 0; i < pointsRaw.length; i++) {
        //  get rid of last point, which is a starting one
        if (i === (pointsRaw.length - 1) && pointsRaw[0] === pointsRaw[pointsRaw.length - 1]) {
            break;
        }
        points.push(this.extractCoordinates(pointsRaw[i]));
    }

    return points;
};

Bingo.Map.PositionSelection.prototype.processLocalitiesFromInput = function () {
    if (this.localitySelectize) {
        const localitySelectizeValue = this.localitySelectize.getValue();
        if (localitySelectizeValue) {
            const localityIds = localitySelectizeValue.split(',');
            this.unsetDrawings();
            this.handleLocalities();
            this.localities = [];
            $.nette.ajax({
                type: 'GET',
                url: '/api/v1/locality/details',
                data: {localityIds},
                success: (returnData) => {
                    returnData.data.data.forEach((returnLocality) => {
                        this.localities.push({
                            polygon: returnLocality.area ? returnLocality.area : null,
                            circle: returnLocality.circle ? returnLocality.circle : null,
                        });
                    });
                    this.redrawLocalitiesDrawings();
                },
            });
        } else {
            this.unsetDrawings(false);
        }
    }
};


Bingo.Map.PositionSelection.prototype.getFormDraw = function () {
    return $(`#${this.DRAW_FIELD}`).val();
};

Bingo.Map.PositionSelection.prototype.setFormDraw = function (draw) {
    $(`#${this.DRAW_FIELD}`).val(draw ? 1 : 0);
};

Bingo.Map.PositionSelection.prototype.updateLastLocation = function () {
    this.lastLocation = {
        location: this.getFormLocation(),
        coordinates: this.getFormCoordinates(),
    };
    $(`#${this.LOCATION_FIELD}`).attr('placeholder', this.lastLocation.location);
};

Bingo.Map.PositionSelection.prototype.fitBounds = function (bounds) {
    Bingo.Map.Instance.prototype.fitBounds.call(this, bounds, this.MAX_ZOOM_LEVEL);
};

Bingo.Map.PositionSelection.prototype.initAutocompletion = function () {
    const input = document.getElementById(this.LOCATION_FIELD);
    if (input === null) {
        return;
    }
    const autocomplete = new google.maps.places.Autocomplete(input);

    autocomplete.addListener('place_changed', () => {
        const place = autocomplete.getPlace();
        if (!place.geometry) { // The autocomplete object has changed, but nothing was selected -> do nothing
            return;
        }
        document.getElementById(this.LOCATION_FIELD).blur();
        this.getArea().setCenter(place.geometry.location);
        this.unsetDrawings();

        if (this._originPage === Bingo.Map.ORIGIN_PAGE_MODE.NEW_OFFER || this._originPage === Bingo.Map.ORIGIN_PAGE_MODE.PROJECT) {
            // offer/property location select
            this.drawNormalMarker(place.geometry.location);
            this.handleMarker();
            $(`#${this.COORDINATES_FIELD}`).val(`${this._marker.position.lat().toFixed(6)},${this._marker.position.lng().toFixed(6)}`);
            $(`input#${this.RADIUS_FIELD}`).val(null);
            $(`#${this.POLYGON_FIELD}`).val(null);
        } else {
            // offer search map
            this.drawTargetMarker(place.geometry.location);
            const newCircle = Bingo.Map.PositionSelectionCircleOptions;
            newCircle.center = place.geometry.location;
            newCircle.radius = Bingo.Map.FALLBACK_RADIUS * 1000;
            newCircle.map = this.getArea();
            this._circle = new google.maps.Circle(newCircle);
            this.addCircleListeners();
            this.addCircleLabel();
            this.drawingMode = null;
            $(`input#${this.RADIUS_FIELD}`).val(Bingo.Map.FALLBACK_RADIUS);
            $(`#${this.COORDINATES_FIELD}`).val(`${this._circle.center.lat().toFixed(6)},${this._circle.center.lng().toFixed(6)}`);
            $(`#${this.POLYGON_FIELD}`).val(null);
            triggerOfferSearchForm($(`input#${this.LOCATION_FIELD}`).closest('form'));
        }
    });
    // Prevent form submission on autocompletion selection by enter
    google.maps.event.addDomListener(input, 'keydown', (e) => {
        if (e.keyCode === 13) {
            const googleDOMNodes = document.getElementsByClassName('pac-container');
            if (googleDOMNodes.length > 0) {
                e.preventDefault();
            }
        }
    });
};

Bingo.Map.PositionSelection.prototype.initLocation = function () {
    if (this.mode !== Bingo.Map.MODE_POSITION_SELECT || this._marker || this._target) {
        return;
    }

    const coordinates = this.getFormCoordinates();
    if (coordinates) {
        this.drawNormalMarker(coordinates);
    }
};

Bingo.Map.PositionSelection.prototype.syncLocation = function (location, locationName) {
    const geocoder = new google.maps.Geocoder();

    const locationFieldElement = $(`#${this.LOCATION_FIELD}`);
    if (locationName) {
        locationFieldElement.val(locationName);
        locationFieldElement.focusout();
        this.updateLastLocation();
        return;
    }
    geocoder.geocode({location}, (results, status) => {
        if (status === google.maps.GeocoderStatus.OK && results[0]) {
            // The results are sorted from most specific to the least specific
            // See: https://developers.google.com/maps/documentation/javascript/geocoding
            locationFieldElement.val(results[0].formatted_address);
        } else {
            // Reset field to prevent saving old value
            locationFieldElement.val('');
        }
        locationFieldElement.focusout();
        locationFieldElement.trigger('change');
        this.updateLastLocation();
    });
};

Bingo.Map.PositionSelection.prototype.getMarkerBounds = function () {
    const marker = this.position;
    return marker._circle.getBounds();
};

Bingo.Map.PositionSelection.prototype.getRadius = function () {
    return this.radius;
};

Bingo.Map.PositionSelection.prototype.setLastActive = function (selector) {
    this.unsetLastActiveTool();
    $('.draw-tools').addClass('active-tool');
    $(Bingo.Map.PositionSelectionDrawToolElement).find(selector).addClass('active-tool').addClass('active-last');
};

Bingo.Map.PositionSelection.prototype.unsetActiveTool = function () {
    $(`${Bingo.Map.PositionSelectionDrawToolElement} .active-tool`).removeClass('active-tool');
    if ($(`${Bingo.Map.PositionSelectionDrawToolElement} .active-tool`).length === 0 && $(`${Bingo.Map.PositionSelectionDrawToolElement} .active-last`).length === 0) {
        $(Bingo.Map.PositionSelectionDrawToolElement).removeClass('active-tool');
    }
};

Bingo.Map.PositionSelection.prototype.unsetLastActiveTool = function () {
    $(`${Bingo.Map.PositionSelectionDrawToolElement} .active-last`).removeClass('active-last');
};
